export function toggleItem() {
	document.querySelectorAll('.toggle__button').forEach((item) => {
		item.addEventListener('click', function (item) {
			item.target.closest('.toggle').classList.toggle('hide')
		})
	})

	const button = document.getElementById("showmoreimg");
	if(button) {
		button.addEventListener("click", function(e) {
			e.preventDefault();

			document.querySelectorAll(".hidden-image").forEach(function(el) {
				el.classList.remove("hidden-image");
			});

			this.remove();
		});
	}
}
